export default "__VITE_ASSET__CoZApKlh__"